import _http_v1 from "../../http_requests/_http_v1"
import store from "./store/store"
import('../../../styles/components/map/filter_marker_form.css')

export default function (options){
    let container = options.container
    let ugrhis_select, cities_select
    let filter_options = {
        ugrhi_ids:[],
        city_ids:[]
    }
    let selectpickerOptions = {liveSearch:true, noneSelectedText:"", noneResultsText:"Nada encontrado para {0}",actionsBox:true, deselectAllText: "", selectAllText: ""}
    this.generate = () =>{
        $(container).html("<div class='form-group ugrhi'></div><div class='form-group city'></div>")
        getUgrhis()
        getCities()
    }

    function getUgrhis(){
        _http_v1.request('ugrhis', 'GET', {}).then(ugrhis=>{
            let label = document.createElement('label')
            label.innerText = "Ugrhi"
            $(container).find('.form-group.ugrhi').append(label)
            ugrhis_select = generateSelect(ugrhis, 'cod', 'name')
            $(ugrhis_select).attr('multiple', true)
            $(container).find('.form-group.ugrhi').append(ugrhis_select)
            $(ugrhis_select).selectpicker(selectpickerOptions)

            //bugado, ta vindo sempre com a primeira option selecionada
            $(ugrhis_select).selectpicker('deselectAll');

            // $(ugrhis_select).attr('multiple',true)
            $(ugrhis_select).on('change',function(){
                filter_options.ugrhi_ids = $(ugrhis_select).val()
                store.fluConfig.setFilterOptions('ugrhi_cods', $(ugrhis_select).val())
                // $(document).trigger('map:filter', filter_options)
            })
        })
    }

    function getCities(){
        _http_v1.request('cities', 'GET', {}).then(data=>{
            cities = data //var global pra ajudar
            let label = document.createElement('label')
            label.innerText = "Cidade"
            $(container).find('.form-group.city').append(label)
            cities_select = generateSelect(data, 'cod_ibge', 'name')
            $(cities_select).attr('multiple', true)
            $(container).find('.form-group.city').append(cities_select)
            $(cities_select).selectpicker(selectpickerOptions)

            //bugado, ta vindo sempre com a primeira option selecionada
            $(cities_select).selectpicker('deselectAll');

            // $(ugrhis_select).attr('multiple',true)
            $(cities_select).on('change',function(){
                filter_options.city_ids = $(cities_select).val()
                store.fluConfig.setFilterOptions('city_ibges', $(cities_select).val())
                // $(document).trigger('map:filter', filter_options)
            })
        })
    }

    function generateSelect(options, id_field, name_field){
        let select = document.createElement('select')
        $(select).addClass('form-control')
        // $(select).append("<option></option>")
        
        options.forEach(option=>{
            let opt = document.createElement('option')
            opt.value = option[id_field]
            opt.innerHTML = option[name_field]
            select.appendChild(opt)
        })

        

        return select
    }
}